import React, { useState } from 'react';
import uuid from "react-uuid";
import { Link } from "react-router-dom";
import { Link as Link1 } from 'react-scroll'
import { authService } from "../../auth";
import { getCDNUrl } from "../../commons/CommonFunctions";
import Share from "../../commons/Share";
import mappingUtils from "../../project/component/commons/utils/mappingUtils";

function HashTagsTopSection(props) {
    const [userData, setUserData] = useState(authService.getUserDetailsFromLocalStorage())
    const [loginSuccess] = useState(authService.isAuthenticated());

    const getOptimizedImage = (personalInfo) => {
        if (personalInfo.resizedProfileImages && personalInfo.resizedProfileImages['200x200'] != null) {
            return personalInfo.resizedProfileImages['200x200'];
        }else if (personalInfo.resizedProfileImages && personalInfo.resizedProfileImages['300x300'] != null) {
            return personalInfo.resizedProfileImages['300x300'];
        }
        return personalInfo.profileImage;
    }

    const hashtagFilterBtn = (type) => {    
        if(type == 'filter') {
            window.$(".expHashMainRelatedTags").toggleClass("active");
        } else {
            window.$(".expHashMainRelatedTags").removeClass("active");
        }
    }

    return (
        <div className={"expHashMainTop expHashSection" + (props.isDisplay ? ' individual' : '')}>

            {props.isDisplay && <div className="profpic">

                {props?.hashTagType === "COMMUNITY" ?
                    <div className="profpicinn">
                        <Link to={`/community/${props?.userDetails?.slug}`}>
                            {props.userDetails ?
                                <img
                                    src={(props.userDetails && props.userDetails.profileImage) ? getCDNUrl(getOptimizedImage(props.userDetails, 'profileImage')) : "https://cdn.dscovr.com/images/circleDefault.webp"}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = "https://cdn.dscovr.com/images/circleDefault.png"
                                    }} alt="" /> : null
                            }
                        </Link>
                    </div>  
                    :
                    <div className="profpicinn">
                        <Link to={`/profile/${props.userDetails?.customUrl}`}/* href={props.userDetails && props.userDetails.originalProfileImage && mappingUtils.getPrivacySettingData(props.userDetails.privacySettingConfigDto, 'profile_picture') ? getCDNUrl(props.userDetails.originalProfileImage) : props.userDetails && props.userDetails.type === 'INDIVIDUAL' ? 'https://cdn.dscovr.com/images/users1.png' : 'https://cdn.dscovr.com/images/DefaultBusiness.png'} */>
                            {props.userDetails ?
                                <img
                                src={props.userDetails && mappingUtils.getPrivacySettingData(props.userDetails.privacySettingConfigDto, 'profile_picture') && props.userDetails.profileImage ? getCDNUrl(getOptimizedImage(props.userDetails)) : props.userDetails && props.userDetails.type === 'INDIVIDUAL' ? 'https://cdn.dscovr.com/images/users1.webp' : 'https://cdn.dscovr.com/images/DefaultBusiness.webp'} onError={(e) => { e.target.onerror = null; e.target.src = props.userDetails && props.userDetails.type === 'INDIVIDUAL' ? "https://cdn.dscovr.com/images/users1.png" : 'https://cdn.dscovr.com/images/DefaultBusiness.png' }}
                                alt="" />
                                : null
                            }
                        </Link>
                    </div>
                }
 
            </div>}
            
            <div className="expHashMainTopDesc">
                <h1>#{props.tagName}</h1>
                <div className="expHashTrendTags">
                    {props.relatedTagsListData && props.relatedTagsListData.slice(0, 10).map((item, index) => {
                        return <div className="tagslist">
                            {props.hashTagType === 'global' ? (
                                <a href={'/explore-hashtag/' + item}>{item}</a>) : props?.hashTagType === "COMMUNITY" ? (<a href={'/community/hashtag/' + item + '/' + props.userName}>{item}</a>) : (
                                    <a href={'/profile-hashtag/' + item + '/' + props.userName}>{item}</a>
                                )
                            }
                        </div>
                    })
                    }
                    {props.relatedTagsListData && props.relatedTagsListData.length > 10 &&
                        <a href="#" className="btn morebtnsm">View All</a>
                    }

                </div>
                <div className="expHashMainRelatedTags">
                    {((props.blogListData && props.blogListData.length > 0) || (props.imageListData && props.imageListData.length > 0) || (props.videoListData && props.videoListData.length > 0) ||
                    (props.projectListData && props.projectListData.length > 0) || (props.forumListData && props.forumListData.length) || (props.pollListData && props.pollListData.length > 0) || 
                    (props.othersListData && props.othersListData.length > 0 || props.documentsListData?.length > 0)) ?
                        <button type="button" className="filterBtn" onClick={(e) => hashtagFilterBtn('filter')}>
                            <i className="iFilterSlide"></i>
                        </button> : ''
                    }   
                    <div className="ehRelatedTagsBlk">
                        <ul className="relatedBtns">

                            {props.imageListData && props.imageListData.length > 0 &&
                                <li>
                                    <Link1 href="javascript:void(0)" to="hashTagPhotos" offset={-120} spy={true} smooth={true}>Photos</Link1>
                                </li>
                            }
                            {props.videoListData && props.videoListData.length > 0 &&
                                <li>
                                    <Link1 href="javascript:void(0)" to="hashTagVideoes" offset={-120} spy={true} smooth={true}>Videos</Link1>
                                </li>
                            }
                            {props.blogListData && props.blogListData.length > 0 &&
                                <li>
                                    <Link1 href="javascript:void(0)" to="hashTagBlogs" offset={-120} spy={true} smooth={true}>Articles</Link1>
                                </li>
                            }
                            {props.documentsListData && props.documentsListData.length > 0 &&
                                <li>
                                    <Link1 href="javascript:void(0)" to="hashTagDocuments" offset={-120} spy={true} smooth={true}>Documents</Link1>
                                </li>
                            }

                            {props.projectListData && props.projectListData.length > 0 &&
                                <li>
                                    <Link1 href="javascript:void(0)" to="hashTagProjects" offset={-120} spy={true} smooth={true}>Projects</Link1>
                                </li>
                            }
                            {props.studioListData && props.studioListData.length > 0 &&
                                <li>
                                    <Link1 href="javascript:void(0)" to="hashTagStudio" offset={-120} spy={true} smooth={true}>Studios</Link1>
                                </li>
                            }
                            {props.forumListData && props.forumListData.length > 0 &&
                                <li>
                                    <Link1 href="javascript:void(0)" to="hashTagForums" offset={-120} spy={true} smooth={true}>Forum</Link1>
                                </li>
                            }
                            {props.pollListData && props.pollListData.length > 0 &&
                                <li>
                                    <Link1 href="javascript:void(0)" to="hashTagPolls" offset={-120} spy={true} smooth={true}>Poll</Link1>
                                </li>
                            }
                            {props.othersListData && props.othersListData.length > 0 &&
                                <li>
                                    <Link1 href="javascript:void(0)" to="hashTagOthers" offset={-120} spy={true} smooth={true}>Others</Link1>
                                </li>
                            }
                            
                        </ul>
                        <span className="tagclose" onClick={(e) => hashtagFilterBtn('tagclose')}><i className="iCross" /></span>
                    </div>
                    {loginSuccess === true ? (props.hashTagType === 'global' &&
                        <Share
                            shareUrl="/explore-hashtag/"
                            entityId={props.tagName}
                            slug={props.tagName}
                            entityType={"HASHTAG"}
                            shareId={props.tagName}
                            hideShareOnPortalBtn={true} />
                    ): null }
                    
                </div>

            </div>
        </div>
    )
}

export default HashTagsTopSection;